const validate = {
  rules: {
    email: {
      required: true,
      email: true,
    },
    senha: {
      required: true,
    },
  },
  messages: {
    email: {
      required: "O email é obrigatório.",
      email: "Email inválido.",
    },
    senha: "A senha é obrigatória.",
  },
};

export default validate;
